import { Close } from '@atom-learning/icons'
import * as React from 'react'
import { toast } from 'react-hot-toast'

import { cn } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'
import { useToastContext } from './ToastContext'

export interface ToastCloseButtonProps extends Omit<
  React.ComponentProps<typeof ActionIcon>,
  'label' | 'children'
> {
  onDismiss?: () => void
  label?: string
}

export const ToastCloseButton = ({
  onDismiss,
  label = 'Close alert',
  ...rest
}: ToastCloseButtonProps): React.JSX.Element => {
  const { id } = useToastContext()

  return (
    <ActionIcon
      label={label}
      onClick={() => {
        toast.dismiss(id)
        onDismiss?.()
      }}
      {...rest}
      className={cn(
        'text-white',
        '-mr-2',
        'hover:opacity-80',
        'hover:text-white',
        'focus:opacity-80',
        'focus:text-white'
      )}
    >
      <Icon is={Close} />
    </ActionIcon>
  )
}
